import { IShipmentRecommendationsSourceEnum } from 'types/FMSGraphqlTypes'

export enum ITrackingRecSource {
  INTELLIGENT = 'INTELLIGENT',
  HISTORICAL = 'HISTORICAL',
}

export const getTrackingRecSource = (
  recommendationSource: IShipmentRecommendationsSourceEnum
): ITrackingRecSource => {
  if (recommendationSource === IShipmentRecommendationsSourceEnum.ds_loads_for_you) {
    return ITrackingRecSource.INTELLIGENT
  }
  return ITrackingRecSource.HISTORICAL
}
